import React, { useEffect, useState } from "react";
import { Div } from "../../atoms/Div";
import { ModalCloseButton, Seperator3 } from "../../atoms/StationModal/StationFeeds";
import MESSAGE_SENT from "../../../images/message_sent.svg";
import TrackerOrange from "../../../images/TrackerOrange.svg";
import { Text } from "../../atoms/TextField";
import { SentIcon, SuccessLastTrackedImg, SuccessTrackedImg } from "../../atoms/ConnectStories";
import trackerGrey from "../../../images/trackerGrey.svg";
import { PrimaryButton } from "../../atoms/MyAccountView";
import LottieControl from "./Lottie";
import { Modal } from "react-bootstrap";
import paperAirplane from "../../../images/paper-airplane.svg";
import placeholder from "../../../images/placeholder.svg";
import { TrackedImg, TrackingItem, TrackingWrapper, Card, BirthdayCardButtons, BirthdayCardHeader, BirthdayTracking, PromptPopupWrapper, BirthdayCardContent, LeftSide, RightSide, TitleText, ChildImage, Title, Button, } from "../../atoms/FeedsPopup";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import CircledArrow from "../../../images/circled_right_arrow.svg"
const MessageSuccess = (props) => {

  const [statusTrackingArray, setStatusTrackingArray] = useState(null);
  const [loadanimation, setLoadAnimation] = useState(true);
  const [christmasPrompt, setChristmasPrompt] = useState(false);
  const [birthdayPrompt, setBirthdayPrompt] = useState(false);
  const [whatNext, setWhatNext] = useState(false);
  const artifactCode = props?.selectedTemplate?.artifactCode;
  const ChildName = props?.childFirstName;
  const childImage = props?.childImageURL;
  const imageSource = childImage ? childImage : placeholder;
  const { t } = useTranslation();
  const { persistItemsReducer } = useSelector((state) => state);
  const soIdentifier = persistItemsReducer?.selectedSOData?.soCode;
  const genderCode = props?.selectedChildData?.genderCode;
  const isFarewell =  props?.isCelebrationChild;
  useEffect(() => {
    setTimeout(() => setLoadAnimation(false), 8000)
  }, [props.loading])

  useEffect(() => {
    if (artifactCode === "OCN_CHRISTMAS") {
      setChristmasPrompt(true);
    } else if (artifactCode === "OCN_BIRTHDAY") {
      setBirthdayPrompt(true);
    }
  }, [artifactCode])

  useEffect(() => {
    let statusTrackingArray = props?.statusTracking;
    statusTrackingArray = statusTrackingArray?.filter(
      (content) =>
        content?.statusLabel?.includes("LEVEL2")
        || content?.statusLabel?.includes("LEVEL3")
        || content?.statusLabel?.includes("LEVEL4")
    );
    if (statusTrackingArray?.length > 0) {
      statusTrackingArray = statusTrackingArray?.map((e) => ({ ...e, isTracked: false }));
    }
    if (props.recipientsList?.length > 1) {
      if (statusTrackingArray[0]?.statusDescription1) {
        statusTrackingArray[0].statusDescription1 = t("YourOfficeCountry");
      }
      if (statusTrackingArray[1]?.statusDescription1) {
        statusTrackingArray[1].statusDescription1 = t("YourCommunity");
      }
      if (statusTrackingArray[2]?.statusDescription1) {
        statusTrackingArray[2].statusDescription1 = t("YourChildLetterBack");
      }
    }
    setStatusTrackingArray(statusTrackingArray);

  }, [props.statusTracking])

  const handleClose = () => {
    props.successModalClose();
    props.closeBtnClick(false);
  }
  const handleNext = () => {
    setWhatNext(true);
  }
  const handleSendGift = () => {
    setWhatNext(true);
    let giftUrl = "";

    switch (soIdentifier) {
      case "AUTO":
        giftUrl = christmasPrompt ? "https://worldvision.at/patenservice/weihnachtsgruesse/" : "https://worldvision.at/checkout/geburtstagskarte/";
        break;
      case "FINO":
        giftUrl = "https://www.worldvision.fi/rahalahja-lapselle-lahjoita/";
        break;
      case "NZLO":
        giftUrl = "https://my.worldvision.org.nz/donate/campaign/birthday-bounce-back#oneoff";
        break;
      default:
        console.warn(`Unknown SO identifier: ${soIdentifier}. Cannot open gift URL.`);
        return;
    }
    window.open(giftUrl, "_blank");
  };


  const loadProgressIndicator = (value, index) => {
    if (index === 0) {
      return (
        <>
          <TrackingItem
            key={value?.statusLabel}>

            <SuccessTrackedImg>
              <div></div>
              <img src={trackerGrey} alt="" />
            </SuccessTrackedImg>

            {value?.statusDescription1}
          </TrackingItem>
          <Seperator3 />
        </>

      );
    } if (statusTrackingArray && index === statusTrackingArray.length - 1) {
      return (
        <>
          <TrackingItem
            key={value?.statusLabel}
            id="lasttracker"
          >
            {value?.isTracked ?
              <SuccessLastTrackedImg><img src={TrackerOrange} alt="" /></SuccessLastTrackedImg>
              :
              <SuccessLastTrackedImg><img src={trackerGrey} alt="" /><div></div></SuccessLastTrackedImg>}

            {value?.statusDescription1}
          </TrackingItem>
        </>

      );
    }
    return (
      <>
        <TrackingItem
          key={value?.statusLabel}
        >
          {value?.isTracked ?
            <TrackedImg><img src={TrackerOrange} alt="" /></TrackedImg>
            :
            <SuccessLastTrackedImg><img src={trackerGrey} alt="" /></SuccessLastTrackedImg>}
          {value?.statusDescription1}
        </TrackingItem>
        <Seperator3 />
      </>
    );
  };

  let genderMessage = "";
  if (genderCode) {
    if (genderCode == "F" || genderCode == "G") {
      genderMessage = t("her");
    } else {
      genderMessage = t("his");
    }
  }

  return (
    <>
      <Modal
        id="popup"
        show={props.show}
        className="success-modal-no-border"
      // onClick={()=>props.closeBtnClick(false)}
      >

        <PromptPopupWrapper>
          <ModalCloseButton onClick={handleClose} />
          {loadanimation ? <>
            <Div fullflexdiv>
              <Div successleft>
                <LottieControl />
              </Div>
            </Div>
          </>
            :
            <Div fullflexdiv>
              {isFarewell ? (
                <Div farewell>
                  <Div>
                    <SentIcon src={MESSAGE_SENT} alt="message_sent" />
                    <Text successHeader>{t("YourMessageSent")}</Text>
                  </Div>
                </Div>
              ) : (
                <>
                  {(birthdayPrompt || christmasPrompt) &&
                  !(artifactCode === "OCN_CHRISTMAS" && soIdentifier === "FINO") && soIdentifier !== "JPNO"  ? (
                    <Card>
                      <BirthdayCardHeader>
                        <img src={paperAirplane} alt="Paper Airplane" />
                        <p>{t("YourMessageSent")}</p>
                        {!whatNext ? (
                          <button onClick={handleNext}>
                            {t("HereIsWhat")}
                            <span className="circledArrow">
                              <img src={CircledArrow} alt="" />
                            </span>
                          </button>
                        ) : (
                          <p className="grey">{t("HereIsWhat")}</p>
                        )}
                      </BirthdayCardHeader>
            
                      <Div horizontalSeperator />
            
                      {!whatNext ? (
                        <>
                          <BirthdayCardContent>
                            <LeftSide>
                              <ChildImage src={imageSource} alt="Child" />
                            </LeftSide>
                            <RightSide>
                              <Title>
                                {birthdayPrompt
                                  ? t("BirthdayTitle", { ChildName })
                                  : christmasPrompt
                                  ? t("ChristmasTitle", { ChildName })
                                  : ""}
                              </Title>
                              <TitleText>
                                {birthdayPrompt
                                  ? t("BirthdayDescription", { ChildName, genderMessage })
                                  : christmasPrompt
                                  ? t("ChristmasDescription", { ChildName, genderMessage })
                                  : ""}
                              </TitleText>
                              <TitleText>
                                {birthdayPrompt
                                  ? t("BirthdayJoy")
                                  : christmasPrompt
                                  ? t("ChristmasJoy")
                                  : ""}
                              </TitleText>
                            </RightSide>
                          </BirthdayCardContent>
            
                          <BirthdayCardButtons>
                            <Button onClick={handleSendGift}>{t("YesSendGift")}</Button>
                            <Button onClick={handleClose}>{t("NotThisTime")}</Button>
                          </BirthdayCardButtons>
                        </>
                      ) : (
                        <BirthdayTracking>
                          <TrackingWrapper height="38.5vh">
                            <ul>
                              {statusTrackingArray?.map((item, index) =>
                                loadProgressIndicator(item, index)
                              )}
                            </ul>
                          </TrackingWrapper>
                        </BirthdayTracking>
                      )}
                    </Card>
                  ) : (
                    <>
                      <Div successwrapper>
                        <Div successleft>
                          <SentIcon src={MESSAGE_SENT} alt="message_sent" />
                          <Text successHeader>{t("YourMessageSent")}</Text>
                          <Text successmodalmsg>{t("HereIsWhat")}</Text>
                        </Div>
                      </Div>
                      <Div verticalSeperator />
                      <Div sentTrackerWrapper>
                        <TrackingWrapper height="38.5vh">
                          <ul>
                            {statusTrackingArray?.map((item, index) =>
                              loadProgressIndicator(item, index)
                            )}
                          </ul>
                        </TrackingWrapper>
                        <PrimaryButton successbutton onClick={handleClose}>
                          <span>{t("BackToConnect")}</span>
                        </PrimaryButton>
                      </Div>
                    </>
                  )}
                </>
              )}
            </Div>
            

          }
        </PromptPopupWrapper>
      </Modal>
    </>
  )
}

export default MessageSuccess; 